import { useMediaQuery, useTheme } from "@mui/material"

export const useResponsive = () => {
  const theme = useTheme()
  // 0, 600, 900, 1200, 1536
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"))
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"))
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"))
  const isMediumScreen = useMediaQuery(theme.breakpoints.between("sm", "md"))
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("xl"))

  return {
    isMobile,
    isTablet
    // isDesktop,
    // isSmallScreen,
    // isMediumScreen,
    // isLargeScreen,
    // theme
  }
}
